import React, { useState } from "react";
import { CDN_URL, BUCKET_NAME, PRODUCTS_IMAGES_FOLDER } from "../../../shared/utils/constants";
import { getImageUrl } from "../../../shared/utils/imageUtils";
import { IMAGE_PRESETS } from "../../../shared/utils/imagePresets";

/** A category's image from the API (square thumbnail); an icon when it has none or it fails to load. */
const CategoryThumb = ({ image, className }) => {
  const [failed, setFailed] = useState(false);
  return (
    <span className={className}>
      {image && !failed ? (
        <img
          src={getImageUrl({
            cdnUrl: CDN_URL,
            bucket: BUCKET_NAME,
            key: `${PRODUCTS_IMAGES_FOLDER}/${image}`,
            transforms: IMAGE_PRESETS.THUMBNAIL_SQUARE,
          })}
          alt=""
          loading="lazy"
          onError={() => setFailed(true)}
        />
      ) : (
        <i className="ph ph-squares-four" aria-hidden="true" />
      )}
    </span>
  );
};

export default CategoryThumb;
